import React from "react";

const SVG_PROPS = {
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none" as const,
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": true,
};

const STROKE = {
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

/**
 * First page — vertical bar + chevron (product spec).
 * Same stroke weight and corner style as the rest of the set.
 */
export const PaginationFirstIcon: React.FC = () => (
  <svg {...SVG_PROPS}>
    <path
      d="M11.332 12L7.33203 8L11.332 4"
      {...STROKE}
    />
    <path d="M4.66797 4V12" {...STROKE} />
  </svg>
);

/** Previous page — single chevron. */
export const PaginationPrevIcon: React.FC = () => (
  <svg {...SVG_PROPS}>
    <path
      d="M11.332 12L7.33203 8L11.332 4"
      {...STROKE}
    />
  </svg>
);

/** Next page — single chevron (horizontal mirror of prev). */
export const PaginationNextIcon: React.FC = () => (
  <svg {...SVG_PROPS}>
    <path
      d="M4.668 12L8.668 8L4.668 4"
      {...STROKE}
    />
  </svg>
);

/** Last page — chevron + vertical bar (mirror of first). */
export const PaginationLastIcon: React.FC = () => (
  <svg {...SVG_PROPS}>
    <path
      d="M4.668 12L8.668 8L4.668 4"
      {...STROKE}
    />
    <path d="M11.332 4V12" {...STROKE} />
  </svg>
);
